import React from "react";
import { NavLink, Link, Outlet } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import "./Marketing.css";

function PublicLayout() {
  const { session } = useAuth();

  return (
    <div className="mk">
      <header className="mk-nav">
        <Link to="/" className="mk-brand">
          TOURNAMENT CITY
        </Link>
        <nav className="mk-nav-links">
          <NavLink to="/" end className="mk-nav-link">
            Home
          </NavLink>
          <NavLink to="/product" className="mk-nav-link">
            Product
          </NavLink>
          <NavLink to="/contact" className="mk-nav-link">
            Contact
          </NavLink>
          {session ? (
            <Link to="/app" className="mk-nav-cta">
              Open App
            </Link>
          ) : (
            <Link to="/sign-in" className="mk-nav-cta">
              Login
            </Link>
          )}
        </nav>
      </header>

      <main className="mk-main">
        <Outlet />
      </main>

      <footer className="mk-footer">
        <span className="mk-footer-brand">TOURNAMENT CITY</span>
        <nav className="mk-footer-links">
          <Link to="/">Home</Link>
          <Link to="/product">Product</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/sign-in">Login</Link>
        </nav>
        <span className="mk-footer-copy">© Tournament City</span>
      </footer>
    </div>
  );
}

export default PublicLayout;
